import { WeMeetClient, ClientConfig } from '@tencent/wemeet-websdk-next';
import { reportTimeEndXMPPJoinMeeting, reportTimeStartTRTCEnterRoom, reportXMPPJoinSuccess } from 'src/report/aegis';

// eslint-disable-next-line import/no-mutable-exports
let weMeetClient: WeMeetClient = null!;

function initWeMeetClient(config: ClientConfig) {
  weMeetClient = WeMeetClient.getInstance({
    signalServerUrl: config.signalServerUrl,
    sdkAppId: config.sdkAppId,
    district: config.district,
    language: config.language,
  });

  weMeetClient.events.JOIN_MEETING_SUCCESS(() => {
    // 计时结束：XMPP 进房耗时
    reportTimeEndXMPPJoinMeeting();

    reportXMPPJoinSuccess();

    // 计时开始：TRTC 进房耗时
    reportTimeStartTRTCEnterRoom();
  });
}

export { weMeetClient as default, initWeMeetClient };
